<template>
  <fb-form-properties-manager id="form-header-v1-properties-xboo3i" :fields="fields" :formId="formId" />
</template>

<script>
export default {
  name: "FormHeaderV1Properties",
  props: ["formId"],
  data() {
    return {
      fields: [
        {
          type: "richEditor",
          properties: {
            label: "Default value"
          },
          property: "value"
        }
      ]
    };
  }
};
</script>

<style></style>
